<div class="nowrap point short" (click)="handleClick($event)">
  @if (helpText) {
    <button
      class="btn"
      [ngClass]="modeClass"
      type="button"
      (click)="(null)"
      appTooltip="{{ helpText | translate }}"
      tooltipPosition="above"
      [disabled]="disabled"
    ></button>
    <span class="ml-3 c-sea-wave link" appTooltip="{{ helpText | translate }}" tooltipPosition="above">{{ text | translate }}</span>
  }
  @if (!helpText) {
    <button class="btn" [ngClass]="modeClass" type="button" (click)="(null)" [disabled]="disabled"></button>
    <span class="ml-3 c-sea-wave link">{{ text | translate }}</span>
  }
</div>
